import { sanitizeStoresData } from './sanitizer'
import { request, setFlyerStores } from '../../../actions'
import { setStores } from '../../../actions/stores.actions'
import { getGeolocationParam } from '../../helpers'

export function fetchStoresParams(flyerId, geolocationParam) {
  return {
    resource: `flyers/${flyerId}`,
    params: {
      conditions: {
        is_active: '1',
      },
      fields: 'id,retailer_id',
    },
    populate: flyer => ({
      stores: {
        resource: `flyers/${flyer.id}/stores`,
        paginate: false,
        params: {
          conditions: {
            ...geolocationParam,
          },
          fields: 'id,retailer_id,address,phone,lat,lng,city,province,distance,zip',
          sort: 'distance',
        },
      },
      retailer: {
        resource: `retailers/${flyer.retailer_id}`,
        params: {
          fields: 'id,name,slug,category_id',
        },
      },
    }),
  }
}

export function fetchStoresParamsWithDistance(flyerId, geolocationParam, distance) {
  return {
    resource: `flyers/${flyerId}`,
    params: {
      conditions: {
        is_active: '1',
      },
      fields: 'id,retailer_id',
    },
    populate: flyer => ({
      stores: {
        resource: `flyers/${flyer.id}/stores`,
        paginate: false,
        params: {
          conditions: {
            'distance <': distance,
            ...geolocationParam,
          },
          fields: 'id,retailer_id,address,phone,lat,lng,city,province,zip',
          sort: 'distance',
        },
      },
      retailer: {
        resource: `retailers/${flyer.retailer_id}`,
        params: {
          fields: 'id,name,slug,category_id',
        },
      },
    }),
  }
}

export function receiveStores(jsonData) {
  const { id: flyerId, stores } = jsonData
  const sanitizedStores = sanitizeStoresData(stores)
  return dispatch => {
    dispatch(setStores(sanitizedStores))
    dispatch(setFlyerStores(flyerId, stores))
  }
}

/**
 * Fetches stores data for the specified id flyer
 * caches the request object and dispatches it to the store
 * in order to be checked for multiple request requests
 */
export function fetchStores(flyerId) {
  return (dispatch, getState) => {
    const rId = `flyerStores/${flyerId}`
    const state = getState()
    const geolocationParam = getGeolocationParam(state)
    const params = fetchStoresParams(flyerId, geolocationParam)

    return dispatch(request(rId, params, receiveStores))
  }
}

/**
 * Fetches stores data for the specified id flyer
 * caches the request object and dispatches it to the store
 * in order to be checked for multiple request requests
 */
export function fetchStoresWithDistance(flyerId, distance) {
  return (dispatch, getState) => {
    const rId = `flyerStores/${flyerId}`
    const state = getState()
    const geolocationParam = getGeolocationParam(state)
    const params = fetchStoresParamsWithDistance(flyerId, geolocationParam, distance)
    return dispatch(request(rId, params, receiveStores))
  }
}
